module.exports = __webpack_public_path__ + "img/jhubzcom.a83584bf.svg";